import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        margin: 10
    },
    gridBtn: {
        textAlign: 'left'
    },
    rootList: {
        margin: 10
    }
}))
